"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleInheritAttachedStylesheet = exports.reorderAttachedStylesheets = exports.removeAttachedStylesheet = exports.addAttachedStylesheet = exports.saveDefaultOwnerPropertyValues = exports.saveDefaultContactPropertyValues = exports.saveDefaultCompanyPropertyValues = exports.cancelChangeProperties = exports.changeDefaultOwnerPropertyValue = exports.changeDefaultContactPropertyValue = exports.changeDefaultCompanyPropertyValue = exports.changeSelectedProperty = exports.changePropertySearch = exports.InteractionsActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _interactions = require("../constants/interactions");

var _mapPayloadTo = _interopRequireDefault(require("redux-less/utils/mapPayloadTo"));

var InteractionsActionTypes = (0, _namespacedKeyMirror.default)({
  CHANGE_PROPERTY_SEARCH: null,
  CHANGE_DEFAULT_COMPANY_PROPERTY_VALUE: null,
  CHANGE_DEFAULT_CONTACT_PROPERTY_VALUE: null,
  CHANGE_DEFAULT_OWNER_PROPERTY_VALUE: null,
  CHANGE_SELECTED_PROPERTY: null,
  SAVE_DEFAULT_COMPANY_PROPERTY_VALUES: null,
  SAVE_DEFAULT_CONTACT_PROPERTY_VALUES: null,
  SAVE_DEFAULT_OWNER_PROPERTY_VALUES: null,
  CANCEL_CHANGE_PROPERTIES: null,
  ADD_ATTACHED_STYLESHEET: null,
  REMOVE_ATTACHED_STYLESHEET: null,
  REORDER_ATTACHED_STYLESHEETS: null,
  TOGGLE_INHERIT_ATTACHED_STYLESHEET: null
}, _UrlPathParams.PAGES);
exports.InteractionsActionTypes = InteractionsActionTypes;
var changePropertySearch = (0, _fluxActions.createAction)(InteractionsActionTypes.CHANGE_PROPERTY_SEARCH, (0, _mapPayloadTo.default)(_interactions.PROPERTY_SEARCH));
exports.changePropertySearch = changePropertySearch;
var changeSelectedProperty = (0, _fluxActions.createAction)(InteractionsActionTypes.CHANGE_SELECTED_PROPERTY, (0, _mapPayloadTo.default)(_interactions.SELECTED_PROPERTY));
exports.changeSelectedProperty = changeSelectedProperty;
var changeDefaultCompanyPropertyValue = (0, _fluxActions.createAction)(InteractionsActionTypes.CHANGE_DEFAULT_COMPANY_PROPERTY_VALUE, (0, _mapPayloadTo.default)(_interactions.SELECTED_PROPERTY, 'allDomainsOrDomainName', 'value'));
exports.changeDefaultCompanyPropertyValue = changeDefaultCompanyPropertyValue;
var changeDefaultContactPropertyValue = (0, _fluxActions.createAction)(InteractionsActionTypes.CHANGE_DEFAULT_CONTACT_PROPERTY_VALUE, (0, _mapPayloadTo.default)(_interactions.SELECTED_PROPERTY, 'allDomainsOrDomainName', 'value'));
exports.changeDefaultContactPropertyValue = changeDefaultContactPropertyValue;
var changeDefaultOwnerPropertyValue = (0, _fluxActions.createAction)(InteractionsActionTypes.CHANGE_DEFAULT_OWNER_PROPERTY_VALUE, (0, _mapPayloadTo.default)(_interactions.SELECTED_PROPERTY, 'allDomainsOrDomainName', 'value'));
exports.changeDefaultOwnerPropertyValue = changeDefaultOwnerPropertyValue;
var cancelChangeProperties = (0, _fluxActions.createAction)(InteractionsActionTypes.CANCEL_CHANGE_PROPERTIES);
exports.cancelChangeProperties = cancelChangeProperties;
var saveDefaultCompanyPropertyValues = (0, _fluxActions.createAction)(InteractionsActionTypes.SAVE_DEFAULT_COMPANY_PROPERTY_VALUES);
exports.saveDefaultCompanyPropertyValues = saveDefaultCompanyPropertyValues;
var saveDefaultContactPropertyValues = (0, _fluxActions.createAction)(InteractionsActionTypes.SAVE_DEFAULT_CONTACT_PROPERTY_VALUES);
exports.saveDefaultContactPropertyValues = saveDefaultContactPropertyValues;
var saveDefaultOwnerPropertyValues = (0, _fluxActions.createAction)(InteractionsActionTypes.SAVE_DEFAULT_OWNER_PROPERTY_VALUES);
exports.saveDefaultOwnerPropertyValues = saveDefaultOwnerPropertyValues;
var addAttachedStylesheet = (0, _fluxActions.createAction)(InteractionsActionTypes.ADD_ATTACHED_STYLESHEET, function (stylesheet) {
  return {
    stylesheet: stylesheet
  };
});
exports.addAttachedStylesheet = addAttachedStylesheet;
var removeAttachedStylesheet = (0, _fluxActions.createAction)(InteractionsActionTypes.REMOVE_ATTACHED_STYLESHEET, function (id) {
  return id;
});
exports.removeAttachedStylesheet = removeAttachedStylesheet;
var reorderAttachedStylesheets = (0, _fluxActions.createAction)(InteractionsActionTypes.REORDER_ATTACHED_STYLESHEETS, function (stylesheets) {
  return {
    stylesheets: stylesheets
  };
});
exports.reorderAttachedStylesheets = reorderAttachedStylesheets;
var toggleInheritAttachedStylesheet = (0, _fluxActions.createAction)(InteractionsActionTypes.TOGGLE_INHERIT_ATTACHED_STYLESHEET, function (value) {
  return {
    value: value
  };
});
exports.toggleInheritAttachedStylesheet = toggleInheritAttachedStylesheet;